import { render, staticRenderFns } from "./FreeRecord.vue?vue&type=template&id=7633b77c&scoped=true"
import script from "./FreeRecord.vue?vue&type=script&lang=js"
export * from "./FreeRecord.vue?vue&type=script&lang=js"
import style0 from "./FreeRecord.vue?vue&type=style&index=0&id=7633b77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7633b77c",
  null
  
)

export default component.exports